// import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

window.animations = function () {
  // animações banner
  let hero = document.querySelector('.hero');
  if (hero) {
    const leterringPlus = document.querySelector('.lettering-plus');
    const leterringYoki = document.querySelector('.lettering-yoki');
    const leterringKitano = document.querySelector('.lettering-kitano');
    const illustration1 = document.querySelector('.illustration1');
    const illustration2 = document.querySelector('.illustration2');
    const heroLights = document.querySelector('.hero__lights');
    const confete1 = document.querySelector('.confete1');
    const confete2 = document.querySelector('.confete2');
    const subtitle = document.querySelector('.hero__subtitle');
    const title = document.querySelector('.hero__title');
    const text = document.querySelector('.hero__description');
    let parallax = { trigger: hero, start: 'top top', end: "+=100%", scrub: true }

    let tl = gsap.timeline();
    tl.set(leterringPlus, {y: -100, opacity: 0 });
    tl.set(leterringYoki, {x: -200, opacity: 0 });
    tl.set(leterringKitano, {x: 200, opacity: 0 });
    tl.set(illustration1, { scale:0, opacity: 0 });
    tl.set(illustration2, { scale:0, opacity: 0 });
    tl.set(confete1, {y: 150, opacity: 0 });
    tl.set(confete2, {y: -150, opacity: 0 });
    tl.set(subtitle, {x: 150, opacity: 0 });
    tl.set(title, {x: 150, opacity: 0 });
    tl.set(text, {x: -150, opacity: 0 });
    
    tl
      .to(leterringPlus, { y:0, opacity: 1, duration: .5 }, 'start')
      .to(leterringKitano, { x:0, opacity: 1, duration: .5, ease: "back.out(1.7)", }, 'start+=.5')
      .to(leterringYoki, { x:0, opacity: 1, duration: .5, ease: "back.out(1.7)", }, 'start+=.5')
      .add('complementos')
      .to(illustration1, { opacity: 1, ease: "back.out(1.7)", duration: 0.8, scale: 1}, 'complementos')
      .to(illustration2, { opacity: 1, ease: "back.out(1.7)", duration: 0.8, scale: 1}, 'complementos')
      .to(subtitle, { opacity: 1, ease: "back.out(1.7)", duration: 0.8, x: 0}, 'complementos+=0.1')
      .to(title, { opacity: 1, ease: "back.out(1.7)", duration: 0.8, x: 0}, 'complementos+=0.2')
      .to(text, { opacity: 1, ease: "back.out(1.7)", duration: 0.8, x: 0}, 'complementos+=0.3')
      .to(confete1, { opacity: 1, ease: "back.out(1.7)", duration: 0.8, y: 0}, 'complementos+=0.5')
      .to(confete2, { opacity: 1, ease: "back.out(1.7)", duration: 0.8, y: 0,
        onComplete: function() {
          hero.classList.add('completed'); // then only replace with blue div with new height and width
        }
      }, 'complementos+=0.5', )


    gsap.timeline({ scrollTrigger: parallax }).to('.hero-emoji1',{ y:-190})
    gsap.timeline({ scrollTrigger: parallax }).to('.hero-emoji2',{ y:-190})
  }

  let como_participar = document.getElementById('como-participar');
  if (como_participar) {
    let title = document.querySelector('.participate__title');

    gsap.set('.participate__title', { opacity:0, scale: 0 })

    gsap
      .timeline({ scrollTrigger: { trigger: premios } })
      .to(title, { scale: 1, opacity: 1, duration: 0.5}, 'start')

    gsap.from('.participate__steps-item', {
      scrollTrigger: { 
        trigger: como_participar,
        start: 'top 75%',
        // markers: true,
      },
      y: -60,
      duration: 1.5,
      opacity: 0,
      stagger: { each: 0.3, from: 'start' },
      ease: "elastic.inOut(1, 0.6)",
      // onComplete: function () {
      //   gsap
      //     .timeline()
      //     .to('.participate__title', { y: 0, opacity: 1, duration: 0.5})
      // }
    }); 
  }

  let premios = document.getElementById('premios');
  if (premios) {
    
    let premioCard1 = document.querySelector('.premios__box-item.item--1');
    let premioCard2 = document.querySelector('.premios__box-item.item--2');
    let premioCard3 = document.querySelector('.premios__box-item.item--3');
    let premioCard4 = document.querySelector('.premios__box-item.item--4');
    let text = document.querySelector('.premios__title');

    let parallax = { trigger: premios, start: 'top top', end: "+=100%", scrub: true }

    gsap.set(premioCard1, { opacity: 0, y: 100 });
    gsap.set(premioCard2, { opacity: 0, y: 100 });
    gsap.set(premioCard3, { opacity: 0, y: 100 });
    gsap.set(premioCard4, { opacity: 0, y: 100 });
    gsap.set(text, { opacity:0, scale: 0 });   

    gsap
      .timeline({ scrollTrigger: { 
        trigger: premios,
        start: 'top 75%',
        // markers: true,
      } })
      .to(text, { scale: 1, opacity: 1, duration: 0.5}, 'start')
      .to(premioCard1, { opacity: 1, duration: 0.4, ease: "power3.out", y: 0 })
      .to(premioCard2, { opacity: 1, duration: 0.4, ease: "power3.out", y: 0 })
      .to(premioCard3, { opacity: 1, duration: 0.4, ease: "power3.out", y: 0 })
      .to(premioCard4, { opacity: 1, duration: 0.4, ease: "power3.out", y: 0 })
  }

  let ganhadores = document.getElementById('ganhadores');
  if (ganhadores) {
    let tabLink1 = document.querySelector('.tab-link.item--1');
    let tabLink2 = document.querySelector('.tab-link.item--2');
    let tabLink3 = document.querySelector('.tab-link.item--3');
    let tabLink4 = document.querySelector('.tab-link.item--4');
    let tabContent = document.querySelector('.js-tab-contents');
    let text = document.querySelector('.ganhadores__title');

    let parallax = { trigger: ganhadores, start: 'top top', end: "+=100%", scrub: true }

    gsap.set(tabLink1, { opacity: 0, y: -60 });
    gsap.set(tabLink2, { opacity: 0, y: -60 });
    gsap.set(tabLink3, { opacity: 0, y: -60 });
    gsap.set(tabLink4, { opacity: 0, y: -60 });
    gsap.set(tabContent, { opacity: 0, y: 60 });
    gsap.set(text, { opacity:0, scale: 0 });   

    gsap
      .timeline({ scrollTrigger: { 
        trigger: ganhadores,
        start: 'top 80%',
        // markers: true,
      } })
      .to(text, { scale: 1, opacity: 1, duration: 0.5}, 'start')
      .to(tabLink1, { opacity: 1, duration: 0.4, ease: "power3.out", y: 0 })
      .to(tabLink2, { opacity: 1, duration: 0.4, ease: "power3.out", y: 0 })
      .to(tabLink3, { opacity: 1, duration: 0.4, ease: "power3.out", y: 0 })
      .to(tabLink4, { opacity: 1, duration: 0.4, ease: "power3.out", y: 0 })
      .to(tabContent, { opacity: 1, ease: "power3.out", y: 0 })

    gsap.timeline({ scrollTrigger: parallax }).to('.ganhadores-emoji1',{ y:-190})
  }

  let sectionCalendario = document.getElementById('calendario');
  if (sectionCalendario) {
    gsap.from('.js-items-calendar-animation', {
      scrollTrigger: {
        trigger: sectionCalendario,
        start: "top 70%",
        end: "+=100%",
      },
      y: -50, duration: 1.5, opacity: 0, stagger: 0.1, ease: "elastic.inOut(1, 0.6)"
    }); 
  }  

  let duvidas = document.getElementById('duvidas');
  if (duvidas) {
    let title = document.querySelector('.duvidas__title');

    gsap.set('.duvidas__title', { opacity:0, scale: 0 })

    gsap
      .timeline({ scrollTrigger: { 
        trigger: duvidas,
        start: 'top 50%', 
      } })
      .to(title, { scale: 1, opacity: 1, duration: 0.5}, 'start')
      
    gsap.from('.accordion-item', {
      scrollTrigger: { 
        trigger: duvidas,
        start: "top 50%",
        end: "+=100%", 
      },
      x: -60,
      duration: 0.9,
      opacity: 0,
      stagger: { each: 0.3, from: 'start' },
      ease: "elastic.inOut(1, 0.6)",
      // onComplete: function () {
      //   gsap
      //     .timeline()
      //     .to('.duvidas__title', { y: 0, opacity: 1, duration: 0.3})
      // }
    }); 
  }

}

